import styled from '@emotion/styled'
import React from 'react'
import { handleChipColor } from './utils'

export const ExecutiveSummarySection = ({ executiveSummary }: any) => (
  <>
    {executiveSummary?.summaryHeader}

    <ul>
      {executiveSummary?.bulletpoints.length &&
        executiveSummary?.bulletpoints.map((item: string) => (
          <li key={item}>{item}</li>
        ))}
    </ul>

    <StatContainer>
      HOW MANY ORGANIZATIONS ARE USING THE PLATFORM?
      <StyledChip
        color={handleChipColor(
          executiveSummary?.numberOrgsOnPlatformUp,
          executiveSummary?.numberOrgsOnPlatformDown
        )}
      >
        {executiveSummary?.numberOrgsOnPlatform}
      </StyledChip>
    </StatContainer>

    <StatContainer>
      HOW MANY USERS HAVE LOGGED IN
      <StyledChip
        color={handleChipColor(
          executiveSummary?.numberUsersLoggedInUp,
          executiveSummary?.numberUsersLoggedInDown
        )}
      >
        {executiveSummary?.numberUsersLoggedIn}
      </StyledChip>
    </StatContainer>

    <StatContainer>
      HOW MANY ORGANIZATIONS ARE ENROLLED?
      <StyledChip
        color={handleChipColor(
          (executiveSummary?.fractionOrgsEnrolledUp,
          executiveSummary?.fractionOrgsEnrolledDown)
        )}
      >
        {executiveSummary?.fractionOrgsEnrolled}
      </StyledChip>
    </StatContainer>
  </>
)

const StyledChip = styled.div<{ color: string }>`
  height: 24px;
  padding: 2px;
  margin: 2px;
  background-color: ${(props) => props.color};
  color: black;
  border-radius: 4px;
  min-width: 35px;
`

const StatContainer = styled.div`
  display: flex;
  justify-content: space-between;
`
